var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"link-back",attrs:{"color":"primary","disabled":_vm.disabled,"ripple":false,"plain":""},on:{"click":_vm.goBack}},[_c('v-icon',{attrs:{"size":"22","aria-hidden":"true","left":""}},[_vm._v(" mdi-chevron-left ")]),_c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }